{ "compressionlevel":-1,
 "height":14,
 "infinite":false,
 "layers":[
        {
         "draworder":"topdown",
         "id":2,
         "name":"Objects",
         "objects":[
                {
                 "height":0,
                 "id":3,
                 "name":"player",
                 "point":true,
                 "rotation":0,
                 "type":"player",
                 "visible":true,
                 "width":0,
                 "x":96,
                 "y":224
                }, 
                {
                 "ellipse":true,
                 "height":128,
                 "id":6,
                 "name":"target",
                 "rotation":0,
                 "type":"target",
                 "visible":true,
                 "width":128,
                 "x":384,
                 "y":160
                }, 
                {
                 "height":192,
                 "id":11,
                 "name":"",
                 "rotation":0,
                 "type":"collider",
                 "visible":true,
                 "width":32,
                 "x":320,
                 "y":128
                }, 
                {
                 "height":64,
                 "id":15,
                 "name":"",
                 "rotation":0,
                 "type":"collider",
                 "visible":true,
                 "width":288,
                 "x":0,
                 "y":0
                }, 
                {
                 "height":64,
                 "id":16,
                 "name":"",
                 "rotation":0,
                 "type":"collider",
                 "visible":true,
                 "width":288,
                 "x":192,
                 "y":384
                }, 
                {
                 "height":192,
                 "id":17,
                 "name":"",
                 "rotation":0,
                 "type":"collider",
                 "visible":true,
                 "width":64,
                 "x":576,
                 "y":0
                }, 
                {
                 "height":64,
                 "id":18,
                 "name":"",
                 "rotation":0,
                 "type":"collider",
                 "visible":true,
                 "width":96,
                 "x":480,
                 "y":0
                }, 
                {
                 "height":32,
                 "id":19,
                 "name":"",
                 "rotation":0,
                 "type":"collider",
                 "visible":true,
                 "width":32,
                 "x":352,
                 "y":128
                }, 
                {
                 "height":32,
                 "id":20,
                 "name":"",
                 "rotation":0,
                 "type":"collider",
                 "visible":true,
                 "width":32,
                 "x":288,
                 "y":128
                }, 
                {
                 "height":32,
                 "id":21,
                 "name":"",
                 "rotation":0,
                 "type":"collider",
                 "visible":true,
                 "width":32,
                 "x":352,
                 "y":288
                }, 
                {
                 "height":32,
                 "id":22,
                 "name":"",
                 "rotation":0,
                 "type":"collider",
                 "visible":true,
                 "width":32,
                 "x":288,
                 "y":288
                }],
         "opacity":1,
         "type":"objectgroup",
         "visible":true,
         "x":0,
         "y":0
        }],
 "nextlayerid":3,
 "nextobjectid":23,
 "orientation":"orthogonal",
 "properties":[
        {
         "name":"levelName",
         "type":"string",
         "value":"Level 6"
        }, 
        {
         "name":"order",
         "type":"int",
         "value":5
        }],
 "renderorder":"right-down",
 "tiledversion":"1.6.0",
 "tileheight":32,
 "tilesets":[],
 "tilewidth":32,
 "type":"map",
 "version":"1.6",
 "width":20
}